module.exports = __webpack_public_path__ + "static/media/specsuiteAlphaBlue.d872509e.png";